import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import SideMenu from "./SideMenu";

function Layout() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <div className="flex flex-col h-screen bg-gray-100">
      <div className="h-16 shrink-0 z-30">
        <Header onMenuToggle={() => setMobileOpen((v) => !v)} />
      </div>

      <div className="flex flex-1 overflow-hidden relative">
        {/* Mobile overlay backdrop */}
        {mobileOpen && (
          <div
            className="fixed inset-0 z-20 bg-black/50 lg:hidden"
            onClick={() => setMobileOpen(false)}
          />
        )}

        {/* Sidebar — static on desktop, slide-in drawer on mobile */}
        <aside
          className={`
            fixed top-16 bottom-0 left-0 z-20 w-64 transform transition-transform duration-300 ease-in-out
            lg:static lg:top-auto lg:bottom-auto lg:z-auto lg:translate-x-0 lg:shrink-0 lg:block
            ${mobileOpen ? "translate-x-0" : "-translate-x-full"}
          `}
        >
          <SideMenu onNavigate={() => setMobileOpen(false)} />
        </aside>

        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default Layout;
